<template>
  <section class="Quiz_section QuizBase" :class="{ 'Quiz_withIllustration': question.illustration, 'Quiz_withSlider': question.type == 'slider' && selectStyle }" v-if="!onSearch">

      <div class="Quiz_section_wrapper">

        <div class="Quiz_content" ref="content">
          <transition name="bottom" appear mode="out-in">
            <h3 class="Quiz_title" v-if="question.tag">{{ question.tag }}</h3>
          </transition>
          <transition name="bottom" appear mode="out-in">
            <h4 class="Quiz_question" v-if="question.label" v-html="question.label"></h4>
          </transition>
          <transition name="bottom" appear mode="out-in">
            <p class="Quiz_indic" v-if="question.indication" v-html="question.indication"></p>
          </transition>

          <transition name="fade" appear mode="out-in">
            <figure class="Quiz_illustration" v-if="question.illustration">
              <div class="Quiz_illustration_image Quiz_illustration_image_bodymovin" v-if="question.illustration.endsWith('.json')" ref="bodymovin" :style="{ opacity: lottieLoaded ? 1 : 0 }"></div>
              <img class="Quiz_illustration_image" :src="question.illustration" v-else/>
            </figure>
          </transition>

          <!-- <transition name="fade" appear> -->
            <QuizSlider :answers="question.answers" ref="swiper" v-if="question.type == 'slider' && selectStyle" @fieldOk="onSelectOk"/>
          <!-- </transition> -->
        </div>

        <transition name="fade" appear mode="out-in">
          <div class="Quiz_answers" ref="answers" v-if="question.type != 'slider' || question.type == 'slider' && !selectStyle">
            <p class="Quiz_indic Quiz_indic_between" v-if="question.illustration && question.type != 'slider'">Une seule réponse possible</p>
            <QuizAnswer v-if="question.answers && !selectStyle && question.answers.length > 0" :key="index" :answer="answer" v-for="(answer, index) in question.answers" @click.native="response.answer_id = answer.id" :class="{ 'QuizAnswer_selected': response.answer_id == answer.id }"/>
            <QuizInput ref="input" v-if="question.type == 'number' || question.type == 'text'" :type="question.type == 'text' ? 'text' : 'number'" :settings="question.custom || {}" @fieldOk="onFieldOk" />
            <QuizSelect ref="select" v-if="question.answers && selectStyle && question.answers.length > 0" :answers="question.answers" @fieldOk="onSelectOk" :class="{ 'QuizSelect_withIllustration': question.illustration }"/>
          </div>
        </transition>
      </div>
    <!-- <transition :name="$tools.isMobile() ? 'bottom' : null" appear> -->
      <button class="Cta Quiz_cta" :disabled="response.answer_id == null && response.answer_custom == null" @click="validateQuestion" v-if="annexe && annexe.length > 0">Suivant {{ annexe.index }} / {{ annexe.length }} <transition name="fade" mode="out-in"><i class="far fa-arrow-right" key="next" v-if="!onSubmit"></i><i class="fad fa-spinner-third" key="load" v-else></i></transition></button>
      <button class="Cta Quiz_cta" :disabled="response.answer_id == null && response.answer_custom == null" @click="validateQuestion" v-else>Suivant <transition name="fade" mode="out-in"><i class="far fa-arrow-right" key="next" v-if="!onSubmit"></i><i class="fad fa-spinner-third" key="load" v-else></i></transition></button>
    <!-- </transition> -->
  </section>
</template>

<script>
  import page from '@/mixins/page'
  import { mapActions, mapState } from 'vuex'
  import lottie from 'lottie-web'

  import QuizAnswer from "@/components/QuizAnswer"
  import QuizInput from "@/components/QuizInput"
  import QuizSelect from "@/components/QuizSelect"
  import QuizSlider from "@/components/QuizSlider"

  export default {
    name: "QuizBase",
    mixins: [ 'page' ],
    props: [ 'question', 'annexe' ],
    components: { QuizAnswer, QuizInput, QuizSelect, QuizSlider },
    computed: {
      ...mapState([
        'user',
        'userResponses'
      ])
    },
    data() {
      return {
        selectStyle: false,
        anim: null,
        lottieLoaded: false,
        response: {
          token: null,
          answer_id: null,
          answer_custom: null
        },
        onSearch: false,
        onSubmit: false
      }
    },
    methods: {
      ...mapActions([
        'setQualiscore',
        'setUserResponses'
      ]),
      onFieldOk(response)
      {
        this.response.answer_custom = response
      },
      onSelectOk(response)
      {
        console.log('select', response)
        this.response.answer_id = response.id
      },
      validateQuestion()
      {
        if(this.onSubmit) return
        console.log('Validate question : ', this.response)
        this.onSubmit = true
        this.$api.postAnswer(this.question.id, this.response)
        .then(response => {
          if(response.data.participant)
            this.setQualiscore(response.data.participant.qualiscore)

          this.setUserResponses({ question: this.question.ref, answer: this.response.answer_custom ? this.response.answer_custom : this.response.answer_id })

          this.$emit('nextQuestion')
        })
      },
      onResize()
      {
        this.selectStyle = false
        this.$nextTick( () => {
          if(this.$refs.answers)
          {
            let rect = this.$refs.answers.getBoundingClientRect()
            if(rect.width > document.body.querySelector('.Header_wrapper').offsetWidth || ( this.$tools.isMobile() && rect.height > (window.innerHeight - 100 - rect.top) ))
            {
              console.log('select style')
              this.selectStyle = true
            }
          }
        })
      }
    },
    created()
    {
      if(this.question.condition)
      {
        this.onSearch = true
        let question = this.userResponses.find(r => r.question == this.question.condition.question)
        console.log('questionCondition', question)
        // console.log('eval', question.answer.label + ' ' + this.question.condition.value, !eval(question.answer.label + ' ' + this.question.condition.value))
        if(this.question.condition.answers && !this.question.condition.answers.find(r => r == question.answer))
        {
          this.$emit('nextQuestion')
        }else if(this.question.condition.value && !eval(question.answer + ' ' + this.question.condition.value))
        {
          this.$emit('nextQuestion')
        }else{
          this.onSearch = false
        }
      }

      this.response.token = this.user.token
      if(this.question.illustration)
      {
        document.body.querySelector('.QuizBackground').classList.add('QuizBackground_withIllustration')
      }else
      {
        document.body.querySelector('.QuizBackground').classList.remove('QuizBackground_withIllustration')
      }
    },
    beforeDestroy()
    {
      window.removeEventListener('resize', this.onResize)
    },
    mounted()
    {
      if(this.question.illustration && this.question.illustration.endsWith(".json"))
      {
        this.anim = lottie.loadAnimation({
          container: this.$refs.bodymovin,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: this.question.illustration
        });

        this.anim.addEventListener('DOMLoaded', () => { this.lottieLoaded = true; this.onResize() })
      }

      document.body.querySelector('.Header').classList.remove('Header_withTitle')
      window.addEventListener('resize', this.onResize)
      this.onResize()

      if(this.$refs.input && !this.$tools.isTouchDevice())
        this.$refs.input.$refs.field.focus()
    }
  }
</script>

<style lang="stylus" scoped>

  .Quiz_section

    display flex
    flex-direction column
    align-items center

    &_wrapper

      padding-top $s-l

      @media $medium

        padding-top $s-m

  .Quiz

    &_content

      margin 0px auto 0px auto


  .Quiz_withIllustration

    .Quiz

      &_illustration

        margin auto

        @media screen and (min-width: 1100px) and (max-height: 690px)

          display none

        @media $large

          min-height 237px

        @media $medium

          max-width 668px
          min-height 403px

        @media $small

          min-height 160px

        @media $xsmall

          min-height 136px

        @media $xxsmall

          min-height 103px

      &_answers

        margin 0px auto 0px auto

      &_content

        flex-grow 1
        display flex
        flex-direction column
        align-items center
        margin-top 0px
        margin-bottom auto
        justify-content space-between

        @media screen and (min-width: 1100px) and (max-height: 690px)

          justify-content: flex-start

      &_title

        margin-top 0px

      &_question

        margin-top 0px
        margin-bottom 0px


      @media $medium

        &_section_wrapper

          padding-top 0px

        &_content

          background: white
          box-shadow: 0 2px 20px 0 rgba(0,0,0,0.06);
          border-radius: 5px;
          padding 25px 25px 10px 25px
          display flex
          flex-direction column
          align-items center
          justify-content space-between

        &_illustration

          margin auto

        &_answers

          margin 0px auto auto auto

          @media screen and (min-width: 1100px) and (max-height: 690px)

            margin-top auto

  .Quiz_withSlider

    &:not(.Quiz_withIllustration)

      .Quiz

        &_content

          margin-bottom auto

        &_title

          margin-top 0px
          margin-bottom 20px

        &_question

          margin-top 0px
          margin-bottom 0px

        &_indic

          margin-top 20px
          margin-bottom 0px

          @media $medium

            margin-bottom auto

    .Quiz

      &_content

        @media $xsmall

          background-color transparent!important
          padding-left 0px!important
          padding-right 0px!important
          padding-bottom 30px!important
          box-shadow none!important

      &_title

        @media $xsmall

          margin-bottom 10px

      &_indic

        @media $xsmall

          margin-top 10px

    .Quiz

      @media $medium

        &_illustration

          margin auto

        &_content

          flex-grow 1
          height 100%
          position absolute
          top 0px
          left 25px
          width calc(100% - 50px)
          display flex
          flex-direction column
          align-items center
          justify-content space-between
          padding-bottom 45px
          margin-top 0px
          margin-bottom auto
          max-height calc(100vh - 55px - 25px - 60px)
          max-height calc((100vh - 55px - 25px - 60px) - var(--vh, 0px))
</style>
